// VEC-3436: validación de campos obligatorios de un ítem/tarea del presupuesto detallado.
//
// costo y precio son alias del mismo monto: el ítem guarda el valor en 'costo' y la tarea en 'precio',
// pero la config `tickets.presupuesto.(items|tareas).obligatorios` puede pedir cualquiera de los dos.
// Por eso, si el campo obligatorio es 'costo' o 'precio', se resuelve el alias tomando la clave que tenga
// valor (misma lógica que valorCampoObligatorio en TicketPresupuestoDetallado). Sin esto, pedir 'costo'
// sobre una tarea (que guarda 'precio') bloqueaba "Agregar" aunque el precio estuviera cargado.
//
// Para el monto, 0 es un valor VÁLIDO; solo undefined/null/'' cuentan como faltante. El resto de los campos
// (cantidad, servicio, etc.) mantiene la semántica `!valor`, por lo que 0/''/null/undefined sí faltan.

const tieneValor = (valor) => valor !== undefined && valor !== null && valor !== '';

export const faltaCampoObligatorio = (obj, obligatorios) => {
	const lista = obligatorios || [];
	for (let i = 0; i < lista.length; i++) {
		const campo = lista[i];
		if (campo === 'costo' || campo === 'precio') {
			const monto = tieneValor(obj.costo) ? obj.costo : obj.precio;
			if (!tieneValor(monto)) {
				return true;
			}
		} else if (!obj[campo]) {
			return true;
		}
	}
	return false;
};
